import { render, staticRenderFns } from "./SitePlanTabsComponent.vue?vue&type=template&id=54c278f8&"
import script from "./SitePlanTabsComponent.vue?vue&type=script&lang=js&"
export * from "./SitePlanTabsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports